import { collection, getDocs, doc, updateDoc } from "firebase/firestore";
import { deleteDoc } from "firebase/firestore";
import { db } from "../firebase/config";
import { query, where } from "firebase/firestore";
import { getDoc } from "firebase/firestore";
import { addDoc } from "firebase/firestore";
import { auth } from "../firebase/config";
import { getCountFromServer } from "firebase/firestore";

export const getAllGyms = async () => {
  const snapshot = await getDocs(collection(db, "gyms"));

  const gyms = await Promise.all(
    snapshot.docs.map(async (gymDoc) => {
      const gym = gymDoc.data();
      const gymId = gymDoc.id;

      // Count Members
      const membersSnapshot = await getCountFromServer(
        collection(db, "gyms", gymId, "members"),
      );

      // Count Trainers
      const trainersSnapshot = await getCountFromServer(
        collection(db, "gyms", gymId, "trainers"),
      );

      // Get Payments
      const paymentsSnapshot = await getDocs(
        collection(db, "gyms", gymId, "payments"),
      );

      let totalRevenue = 0;

      paymentsSnapshot.forEach((paymentDoc) => {
        const payment = paymentDoc.data();

        if (payment.status === "Paid") {
          totalRevenue += Number(payment.amount || 0);
        }
      });

      // Calculate Days Left
      let daysLeft = "-";

      if (gym.subscriptionEndDate) {
        const today = new Date();

        const expiry = new Date(gym.subscriptionEndDate);

        daysLeft = Math.ceil((expiry - today) / (1000 * 60 * 60 * 24));
      }
      return {
        id: gymId,
        ...gym,

        totalMembers: membersSnapshot.data().count,

        totalTrainers: trainersSnapshot.data().count,

        totalRevenue,

        daysLeft,
      };
    }),
  );

  return gyms;
};

export const rejectGym = async (gymId) => {
  await updateDoc(doc(db, "gyms", gymId), {
    status: "Rejected",

    subscriptionPlan: null,

    subscriptionStatus: "Inactive",

    subscriptionStartDate: null,

    subscriptionEndDate: null,

    paymentStatus: null,

    paymentDone: false,
  });
};

export const extendSubscription = async (gymId, months = 1) => {
  const expiry = new Date();

  expiry.setMonth(expiry.getMonth() + months);

  await updateDoc(doc(db, "gyms", gymId), {
    subscriptionEndDate: expiry.toISOString().split("T")[0],

    subscriptionStatus: "Active",
  });
};

export const deleteGym = async (gymId) => {
  await deleteDoc(doc(db, "gyms", gymId));
};

export const getGymByUserId = async (userId) => {
  const snapshot = await getDoc(doc(db, "gyms", userId));

  if (!snapshot.exists()) return null;

  return {
    id: snapshot.id,
    ...snapshot.data(),
  };
};

export const getCurrentGym = async () => {
  if (!auth.currentUser) return null;

  const snapshot = await getDoc(doc(db, "gyms", auth.currentUser.uid));

  if (!snapshot.exists()) return null;

  return {
    id: snapshot.id,
    ...snapshot.data(),
  };
};

export const deactivateExpiredSubscription = async (gymId) => {
  await updateDoc(doc(db, "gyms", gymId), {
    subscriptionStatus: "Inactive",
  });
};

export const getGymMembers = async (gymId) => {
  const snapshot = await getDocs(collection(db, "gyms", gymId, "members"));

  return snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
};

export const checkExpiryNotifications = async () => {
  const gyms = await getAllGyms();

  const today = new Date();

  for (const gym of gyms) {
    if (!gym.subscriptionEndDate) continue;

    const expiry = new Date(gym.subscriptionEndDate);

    const daysLeft = Math.ceil((expiry - today) / (1000 * 60 * 60 * 24));

    if (daysLeft === 7 || daysLeft === 1 || daysLeft === 0) {
      const q = query(
        collection(db, "adminNotifications"),
        where("gymId", "==", gym.id),
        where("daysLeft", "==", daysLeft),
      );

      const existing = await getDocs(q);

      if (existing.empty) {
        await addDoc(collection(db, "adminNotifications"), {
          gymId: gym.id,
          gymName: gym.gymName,
          ownerName: gym.ownerName,
          email: gym.email,

          subscriptionPlan: gym.subscriptionPlan,
          subscriptionEndDate: gym.subscriptionEndDate,

          daysLeft,
          message: `${gym.gymName} subscription expires in ${daysLeft} day${daysLeft > 1 ? "s" : ""}`,

          type: "Subscription Expiry",

          read: false,
          emailSent: false,

          createdAt: new Date(),
        });
      }
    }
  }
};

export const getRemainingTrialDays = (endDate) => {
  if (!endDate) return 0;

  const today = new Date();

  const expiry = new Date(endDate);

  const diff = Math.ceil((expiry - today) / (1000 * 60 * 60 * 24));

  return diff;
};

export const approveGym = async (gymId) => {
  const gymRef = doc(db, "gyms", gymId);

  const gymSnap = await getDoc(gymRef);

  if (!gymSnap.exists()) return;

  const gym = gymSnap.data();

  const updateData = {
    status: "Approved",
  };

  // ===========================
  // FREE TRIAL USER
  // ===========================

  if (gym.registrationType === "trial") {
    if (!gym.trialUsed) {
      const today = new Date();

      const expiry = new Date();

      expiry.setDate(today.getDate() + 1);

      updateData.subscriptionPlan = "Free Trial";

      updateData.subscriptionStatus = "Active";

      updateData.subscriptionStartDate = today.toISOString().split("T")[0];

      updateData.subscriptionEndDate = expiry.toISOString().split("T")[0];

      updateData.paymentStatus = "Trial";

      updateData.paymentDone = false;

      updateData.trialUsed = true;
    }
  }

  // ===========================
  // PAID USER
  // ===========================
  else if (gym.registrationType === "paid") {
    updateData.subscriptionPlan = null;

    updateData.subscriptionStatus = "Inactive";

    updateData.subscriptionStartDate = null;

    updateData.subscriptionEndDate = null;

    updateData.paymentStatus = "Pending";

    updateData.paymentDone = false;
  }

  await updateDoc(gymRef, updateData);
};
